<div class="form-field__label form-field__label--external">
  {{ field?.label | translateInline }}
</div>
<fmnts-icon-rating
  [(ngModel)]="value"
  [icon]="icon"
  iconSize="1x"
  [max]="5"
  [disabled]="isDisabled"
></fmnts-icon-rating>

<div class="form-field__error-message">
  @if (showError && control.errors) {
    <div>
      {{ control.errors | declarativeErrorMessage: field : declaration }}
    </div>
  }
</div>
